<template>
  <Form ref="configForm" :model="config" v-loading="loading" :disabled="actionType=='detail'" :rules="ruleValidate" :label-width="100" >
     <input v-model="config.id" type="hidden"/>

    <FormItem  :label="this.$t('system.config.name.label')" prop="name">
      <Input v-model="config.name" :placeholder="$t('system.config.name.holder')"/>
    </FormItem>

    <FormItem  :label="this.$t('system.config.sign.label')" prop="sign">
      <Input v-model="config.sign" :placeholder="$t('system.config.sign.holder')"/>
    </FormItem>

    <FormItem  :label="this.$t('system.config.content.label')" prop="content">
      <Input v-model="config.content" :placeholder="$t('system.config.content.holder')"  type="textarea" :rows="3"/>
    </FormItem>

    <FormItem  :label="this.$t('system.config.type.label')" prop="type">
      <Select v-model="config.type" :placeholder="$t('system.config.type.holder')">
        <Option v-for="item in $t('system.config.type.dictionary')" :value="item.value" :key="item.value">{{ item.label }}</Option>
      </Select>
    </FormItem>

    <FormItem  :label="this.$t('system.config.remark.label')" prop="remark">
      <Input v-model="config.remark" :placeholder="$t('system.config.remark.holder')"  type="textarea" :rows="3"/>
    </FormItem>

  </Form>
</template>
<script>
import api from '@/api'

export default {
  data () {
    return {
      config: {
        id: null,
        name: null,
        sign: null,
        content: null,
        type: 0,
        remark: null,
        createTime: null,
        updateTime: null,
        deleted: 0
      },
      loading: false,
      actionType:'add'
    }
  },
  methods: {
    handleSubmit(then,error){
      this.$refs['configForm'].validate(valid => {
        if (valid) {
          if (this.config.id) {
            this.updateConfig(this.config).then(then).error(error)
          } else {
            this.createConfig(this.config).then(then).error(error)
          }
        } else {
          this.$Message.error(this.$t('errorText'))
          error()
        }
      })
    },
    handleReset(){
      this.config.id = ''
      this.actionType = 'add';
      this.$nextTick(()=>this.$refs['configForm'].resetFields());
    },
    getConfig(id,type){
      this.loading = true;
      this.$refs['configForm'].resetFields()
      api.system.Config.detail(id).then(data => {
        this.config = data;
        this.loading = false;
        this.actionType = type;
      }).catch(e => this.loading = false)
    },
    createConfig(config){
      this.loading = true;
      return api.system.Config.add(config)
          .then(response => {
            this.loading = false;
            this.$Message.success(this.$t('successText'))
            return response;
          })
          .catch(e => {
            this.loading = false;
          })
    },
    updateConfig(config){
      this.loading = true;
      return api.system.Config.update(config)
          .then(response => {
            this.loading = false;
            this.$Message.success(this.$t('successText'))
            return response;
          })
          .catch(e => {
            this.loading = false;
          })
    }
  },
  computed: {
    ruleValidate(){
      let validate =  {
      name: [{type: 'string', required: true, message: this.$t('system.config.name.required'),trigger: 'blur'}, {type: 'string',max: 100, message: this.$t('system.config.name.max'),trigger: 'blur'}],
      sign: [{type: 'string', required: true, message: this.$t('system.config.sign.required'),trigger: 'blur'}, {type: 'string',max: 100, message: this.$t('system.config.sign.max'),trigger: 'blur'}],
      content: [{type: 'string', required: true, message: this.$t('system.config.content.required'),trigger: 'blur'}, {type: 'string',max: 500, message: this.$t('system.config.content.max'),trigger: 'blur'}],
      type: [{type: 'number', required: true, message: this.$t('system.config.type.required'),trigger: 'blur'}],
      remark: [{type: 'string',max: 500, message: this.$t('system.config.remark.max'),trigger: 'blur'}]
      }
      if(this.actionType == 'edit'){
        this.$refs['configForm'].fields.forEach(f => {
          if(f.$children[0].disabled){
            delete validate[f.prop]
          }
        })
      }else if(this.actionType == 'detail'){
        return {}
      }
      return validate;
    }
  }
}
</script>
